import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as api from 'core/api';
import * as flights from 'core/flights';
import * as utils from 'core/utils';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class AdvancedProductServiceBrandComponent extends Vue {
    @Prop()
    reservation: flights.ReservationModel;

    @Prop()
    brandKit: api.ProductBrand;

    @Prop()
    gaParams: utils.GoogleAnalyticsParams;

    @Prop({ default: false })
    triggerChangeOnClick: boolean;

    @Prop({ default: false })
    confirmButton: boolean;

    @Prop()
    location?: string;

    selectedProductIdValue = 0;

    get selectedProductId() {
        return this.selectedProductIdValue;
    }

    set selectedProductId(id: number) {
        const product = this.brandKit.products.find(p => p.productId === id)!;
        const prevProduct = this.brandKit.products.find(p => p.productId === this.selectedProductIdValue)!;

        this.selectedProductIdValue = id;

        if (this.triggerChangeOnClick || product !== prevProduct) {
            this.onServiceBrandChange(product, prevProduct);
        }
    }

    get selectedProduct() {
        return this.brandKit.products.find(p => p.productId === this.selectedProductId)!;
    }

    mounted() {
        this.brandKit.products.sort((a, b) => a.sortOrder - b.sortOrder);

        for (const product of this.brandKit.products) {
            const p = this.reservation.products.find(p => p.product.id === product.productId);

            if (p?.selected) {
                this.selectedProductId = p.product.id;
            }
        }
    }

    getName(id: number) {
        if (this.reservation.products) {
            const res = this.reservation.products.find(p => p.product.id === id);
            return res?.product.name;
        }
    }

    getPrice(id: number) {
        if (this.reservation.products) {
            const res = this.reservation.products .find(p => p.product.id === id);
            return res?.product.billingPrice;
        }
    }

    getCurrentCode(id: number) {
        if (this.reservation.products) {
            const res = this.reservation.products.find(p => p.product.id === id);
            return res?.product?.currencyCode;
        }
    }

    selectOrDeselect(id: number) {
        if (this.selectedProductId === id) {
            this.selectedProductId = 0;
        } else {
            this.selectedProductId = id;
        }
    }

    onServiceBrandChange(product: api.Product, prevProduct: api.Product) {
        for (const p of this.reservation.products) {
            if (p.product.id === product.productId) {
                p.selected = true;
            } else if (p.product.id === prevProduct.productId) {
                p.selected = false;
            }
        }

        const stepOnForm = this.reservation.brandedProductKits ? this.reservation.brandedProductKits[0].stepOnForm : '0';
        if (this.location === 'catchup') {
            (<any>this).$ga.sendEvent(
                'product.catchup.svb',
                'btn.ok',
                `product.catchup.svb.kit${this.brandKit.kitId}.id${product.productId}`,
                this.gaParams
            );
        } else {
            (<any>this).$ga.sendEvent(
                'product.svb',
                'btn.ok',
                `product.svb.step${stepOnForm}.kit${this.brandKit.kitId}.id${product.productId}`,
                this.gaParams
            );
        }

        this.$emit('service-brand-change', product, prevProduct);
    }

    onServiceBrandConfirm() {
        this.$emit('service-brand-confirm');
    }
}
